export default "__VITE_ASSET__4beee0e1__"